<template>
  <button @click="$emit('flip')">
    <img src="../../assets/flip.svg" />
  </button>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  emits: {
    flip: () => true,
  },
})
</script>
